module.exports = __webpack_public_path__ + "img/separator-tertiary.3c8234a.svg";